var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],ref:"avatar",staticClass:"avatar",style:({
        backgroundColor: _vm.colour,
        width: _vm.width + 'px',
        fontSize: _vm.fontWidth,
    }),attrs:{"data-initials":_vm.initials,"title":_vm.name}})
}
var staticRenderFns = []

export { render, staticRenderFns }